import React, { ClassAttributes, HTMLAttributes, forwardRef } from "react";

import "./modal.css";

export interface ModalElementUIProps {
    uiBasic?: boolean;
    uiDefaultSizes?: boolean;
}

export type ModalElementProps = HTMLAttributes<HTMLElement> &
    ModalElementUIProps &
    ClassAttributes<HTMLElement>;

const ModalElement = forwardRef<HTMLElement, ModalElementProps>((props, ref) => {
    const { uiBasic = false, uiDefaultSizes = true, className, children, ...rest } = props;

    const classes = [
        "modal-element",
        uiBasic ? "modal-element--basic" : "",
        uiDefaultSizes ? "modal-element--default-sizes" : "",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <article
            {...rest}
            ref={ref as any}
            className={classes}
        >
            {children}
        </article>
    );
});

ModalElement.displayName = "ModalElement";

export default ModalElement;
